<template>
  <div>
    <el-button size="mini"
               type="success"
               @click="onReviewPassed()">审核通过
    </el-button>
    <el-button size="mini"
               type="danger"
               @click="onReviewNotPassed()">审核不通过
    </el-button>
  </div>
</template>

<script>
import ReviewBox from '@views/question-review/components/ReviewBox/index'

export default {
  components: {},
  mixins: [],
  props: {
    salary: [Number, String],
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    /**
     * 审核通过方法
     */
    onReviewPassed () {
      // 审核通过结算确认
      ReviewBox.orderConfirm({
        callback: (data) => {
          this.$emit('pass', data)
        },
      }, this.salary)
    },
    /**
     * 审核不通过方法
     */
    onReviewNotPassed () {
      // 审核不通过结算确认
      ReviewBox.orderBack({
        components: {
          prolongTime: false,
        },
        callback: (data) => {
          this.$emit('not-pass', data)
        },
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/teke-order-review/components/OrderReviewButton.vue